module.exports = __webpack_public_path__ + "static/media/phone2.927b1211.svg";